import { createSlice } from "@reduxjs/toolkit";
import { getMyRanking, getOverallRanking } from "../../api/rankingService";

const rankingSlice = createSlice({
	name: "Ranking",
	initialState: {
		overallRanking: [],
		myRanking: [],
		roundRanking: [],
		myWeeklyRanking: [],
		weeklyRankingLoading: false,
	},
	reducers: {
		setRanking(state, action) {
			state.overallRanking = action.payload;
		},
		setMyRanking(state, action) {
			state.myRanking = action.payload;
		},
		setRoundRanking(state, action) {
			state.roundRanking = action.payload;
		},
		setMyWeeklyRanking(state, action) {
			state.myWeeklyRanking = action.payload;
		},
		setWeeklyRankingLoading(state, action) {
			state.weeklyRankingLoading = action.payload;
		},
	},
});

export const { setRanking } = rankingSlice.actions;
export const { setMyRanking } = rankingSlice.actions;
export const { setRoundRanking } = rankingSlice.actions;
export const { setMyWeeklyRanking } = rankingSlice.actions;
export const { setWeeklyRankingLoading } = rankingSlice.actions;

export const getRankingRequest = (fansUnitedSDK) => async (dispatch) => {
	try {
		const rankingResponse = await getOverallRanking(fansUnitedSDK);
		if (!rankingResponse.data) return;

		dispatch(setRanking(rankingResponse.data));
	} catch (error) {
		throw error;
	}
};

export const getMyRankingRequest = (fansUnitedSDK) => async (dispatch) => {
	try {
		const rankingResponse = await getMyRanking(fansUnitedSDK);
		console.log("rankingResponse.data: ", rankingResponse.data);
		if (!rankingResponse.data) return;

		dispatch(setMyRanking(rankingResponse.data));
	} catch (error) {
		throw error;
	}
};

export const getRoundRankingRequest = (fansUnitedSDK, groupId) => async (dispatch) => {
	try {
		const { getRoundRanking } = await import("../../api/rankingService");
		const rankingResponse = await getRoundRanking(fansUnitedSDK, groupId);
		if (!rankingResponse.data) return;

		dispatch(setRoundRanking(rankingResponse.data));
	} catch (error) {
		throw error;
	}
};

export const getMyWeeklyRankingRequest = (fansUnitedSDK, groupId, userId) => async (dispatch) => {
	try {
		dispatch(setWeeklyRankingLoading(true));
		const { getMyWeeklyRanking } = await import("../../api/rankingService");
		const rankingResponse = await getMyWeeklyRanking(fansUnitedSDK, groupId, userId);
		console.log("Weekly ranking response:", rankingResponse);

		if (rankingResponse.data) {
			dispatch(setMyWeeklyRanking(rankingResponse.data));
		}
	} catch (error) {
		console.error("Error fetching weekly ranking:", error);
		throw error;
	} finally {
		dispatch(setWeeklyRankingLoading(false));
	}
};

export default rankingSlice.reducer;
